import { IDexfSettings } from '@inter-ikea-kompis/types';
import { Action } from 'redux';
import {
	Settings,
	RangeSettings,
	SofaRange,
	SettingsData,
	PredefinedConfiguration,
} from 'sofa-reborn-react';

// State
export interface SettingsState {
	settings: Settings;
	rangeSettings: RangeSettings | null;
	sofaRange: SofaRange;
	predefinedConfigurations: PredefinedConfiguration[];
	features: string[] | null;
	kompisSettings: IDexfSettings | null;
}

// Actions
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_SOFA_RANGE = 'SET_SOFA_RANGE';
export const SET_FEATURES = 'SET_FEATURES';
export const SET_KOMPIS_SETTINGS = 'SET_KOMPIS_SETTINGS';

interface SetSettings extends Action {
	type: typeof SET_SETTINGS;
	value: SettingsData;
}

interface SetSofaRange extends Action {
	type: typeof SET_SOFA_RANGE;
	value: SofaRange;
}

interface SetFeatures extends Action {
	type: typeof SET_FEATURES;
	value: string[];
}

interface SetKompisSettings extends Action {
	type: typeof SET_KOMPIS_SETTINGS;
	value: IDexfSettings;
}

export type SettingsStateActions = SetSettings | SetSofaRange | SetFeatures | SetKompisSettings;
